import React, { useState, useEffect } from "react";
import { useApi } from "../../services/api";
import { Card, CardTitle, CardBody } from "reactstrap";
import HorizontalBar from "./HorizontalBar";

export const TopBuyers = () => {
  const { apiFetch } = useApi();
  const [getTopBuyers, setGetTopBuyers] = useState(null);
  useEffect(() => {
    async function loadData() {

      apiFetch("/api/home/getTopBuyers")
        .then((response) => response.json())
        .then((data) => {
          setGetTopBuyers(data);
          if(data.message === "No transactions found for the specified account")
          setGetTopBuyers(null);
             else
             setGetTopBuyers(data);

        })
        .catch((error) => {
          console.error("Error loading top buyers", error);
        })
    }
    loadData();
  }, []);
  return (
    <>
    <Card className="shadow">
            <CardBody>
              <CardTitle
                style={{ textAlign: "left" }}
                className="card-title-prices"
                data-testid="topbuyertext"
              >
               YTD Sales of Top Customers (UGX Mn)
              </CardTitle>
             <HorizontalBar data={getTopBuyers}/>
            </CardBody>
          </Card>
      
     
    </>
  );
};
